import React from "react";
import { useField } from "formik";
import { FilterItem, FiltersPropTypes } from "Types";

type ValueType = FilterItem | boolean;
type CheckboxProps = {
    setValue: (name: string, value: ValueType | undefined) => void;
    name: string;
    label: string;
    value: ValueType;
};

export default function Checkbox({ label, setValue, value, ...props }: CheckboxProps): JSX.Element {
    const [field] = useField(props);

    return (
        <label className={`rmxo-checkbox-wrapper`}>
            <span className={`rmxo-checkbox ${field.value ? "rmxo-checkbox-checked" : ""}`}>
                <input
                    type="checkbox"
                    {...field}
                    value={field.value ? "1" : undefined}
                    checked={!!field.value}
                    {...props}
                    onChange={(): void => {
                        if (field.value) {
                            setValue(props.name, undefined);
                        } else {
                            setValue(props.name, value);
                        }
                    }}
                />
                <span className="rmxo-checkbox-inner" />
            </span>
            <span className={"rmxo-checkbox-label"}>{label}</span>
        </label>
    );
}

export function renderCheckboxes(collection: FilterItem[], name: string, formik: FiltersPropTypes): JSX.Element[] {
    return collection.map((item) => (
        <Checkbox
            setValue={formik.setFieldValue}
            key={`${name}${item.id}`}
            name={`${name}[${item.id}]`}
            value={item}
            label={item.value}
        />
    ));
}
